import React, { useState } from "react";
import "./style.scss";

class MessageBanner extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isVisible: true,
      isScrolled: false,
    };

    this.handleCloseButtonClick = this.handleCloseButtonClick.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
  }
  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
  }
  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }
  handleScroll() {
    let isScrolled = false;
    if (window.scrollY > 0) {
      isScrolled = true;
    }
    this.setState({
      isScrolled,
    });
  }
  // const [isVisible, setIsVisible] = useState(true);
  handleCloseButtonClick() {
    this.setState({
      isVisible: false,
    });
  }
  render() {
    const { isVisible, isScrolled } = this.state;
    const { message } = this.props;
    const showMessageBanner = isVisible && !isScrolled;
    return (
      <div className={`message-banner ${showMessageBanner ? "" : "hide"}`}>
        <div className="text">{message}</div>
        <button onClick={this.handleCloseButtonClick}>X</button>
      </div>
    );
  }
}

export default MessageBanner;
